import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function WarningIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path d="M0.666656 14H15.3333L7.99999 1.33334L0.666656 14ZM8.66666 12H7.33332V10.6667H8.66666V12ZM8.66666 9.33334H7.33332V6.66668H8.66666V9.33334Z" />
    </SvgIcon>
  );
}

export default WarningIcon;
